import React, { Component } from 'react';
import logo from './logo.svg';
import './CapManagement.css';
import { CustomNav } from '../Components/CustomNav';
import ReactTable from 'react-table';
import { AppContext } from '../Pages/App';
import axios from 'axios';
import 'react-table/react-table.css';
import ordinal from 'ordinal';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { ScenarioHeader } from '../Components/ScenarioHeader';

export const navigatePage = () => dispatch => {
  /* do something before redirection */
  console.log('navigating');
  dispatch(push('/cap'));
};

class CapManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamInfo: [],
      selection: 'projected',
      columns: [],
      homeTeam: jwtTeam(),
      forwards: [],
      defense: [],
      goalies: [],
      injured: [],
      suspended: [],
      ltir: [],
      soir: [],
      buyout: [],
      nonRoster: [],
      terminated: [],
      pto: [],
      retained: [],
      buried: [],
      recapture: [],
      team_projected_cap: [],
      projected: true,
      projected_active: [],
      projected_nonRoster: [],
      projected_nonAsset: [],
      projected_soir: []
    };
  }
  activateLasers(choice, example) {
    //console.log("clickeD" + choice + example);
    if (choice == 'cap') {
      let cols = this.getColumns(this.state.teamInfo.players[0], 'cap_hit');
      this.setState({
        columns: cols,
        selection: 'cap_hit'
      });
    } else if (choice == 'aav') {
      let cols = this.getColumns(this.state.teamInfo.players[0], 'aav');
      this.setState({
        columns: cols,
        selection: 'aav'
      });
    } else if (choice == 'henri') {
      let cols = this.getColumns(this.state.teamInfo.players[0], 'henri');
      this.setState({
        columns: cols,
        selection: 'henri'
      });
    } else if (choice == 'surplus') {
      let cols = this.getColumns(this.state.teamInfo.players[0], 'surplus');
      this.setState({
        columns: cols,
        selection: 'surplus'
      });
    } else if (choice == 'sign') {
      let cols = this.getColumns(this.state.teamInfo.players[0], 'sign_bonus');
      this.setState({
        columns: cols,
        selection: 'sign'
      });
    } else if (choice == 'perf') {
      let cols = this.getColumns(this.state.teamInfo.players[0], 'perf_bonus');
      this.setState({
        columns: cols,
        selection: 'perf'
      });
    } else if (choice == 'minors') {
      let cols = this.getColumns(
        this.state.teamInfo.players[0],
        'minors_salary'
      );
      this.setState({
        columns: cols,
        selection: 'minors'
      });
    } else if (choice == 'projected') {
      this.setState({
        columns: this.projectedColumns,
        selection: 'projected'
      });
    }
  }
  changeTeam(e) {
    if (!e.target.value) {
      return false;
    }
    //console.log("change team");
    //this.setState({team: e.target.value});
    let currentComponent = this;
    let value = e.target.value;
    let url = apiServerUrl + '/team_cap_info?team=' + e.target.value;
    if (e.target.value !== currentComponent.state.homeTeam) {
      currentComponent.setState({
        projected: false
      });
    } // remove option for projected tab if team is not the logged in team
    else {
      currentComponent.setState({
        projected: true
      });
    }
    // Make a request for a user with a given ID
    axios
      .get(url, requestOptions())
      .then(function(response) {
        currentComponent.setState({
          teamInfo: response.data,
          forwards: response.data.players.filter(
            x => x.roster_status === 'FORWARDS'
          ),
          defense: response.data.players.filter(
            x => x.roster_status === 'DEFENSE'
          ),
          goalies: response.data.players.filter(
            x => x.roster_status === 'GOALIES'
          ),
          injured: response.data.players.filter(
            x => x.roster_status === 'INJURED'
          ),
          suspended: response.data.players.filter(
            x => x.roster_status === 'SUSPENDED'
          ),
          ltir: response.data.players.filter(
            x => x.roster_status === 'LONG-TERM'
          ),
          soir: response.data.players.filter(x => x.roster_status === 'SEASON'),
          buyout: response.data.players.filter(
            x => x.roster_status === 'BUYOUT'
          ),
          nonRoster: response.data.players.filter(
            x => x.roster_status === 'NON-ROSTER'
          ),
          terminated: response.data.players.filter(
            x => x.roster_status === 'TERMINATED'
          ),
          pto: response.data.players.filter(x => x.roster_status === 'PTO'),
          retained: response.data.players.filter(
            x => x.roster_status === 'RETAINED'
          ),
          buried: response.data.players.filter(
            x => x.roster_status === 'BURIED'
          ),
          recapture: response.data.players.filter(
            x => x.roster_status === 'RECAPTURE'
          )
        });
      })
      .catch(function(error) {
        //console.log(error);
      });
  }

  componentDidMount() {
    let currentComponent = this;
    axios
      .get(
        apiServerUrl + '/team_cap_info?team=' + this.state.homeTeam,
        requestOptions()
      )
      .then(function(response) {
        /*
        let cols = currentComponent.getColumns(
          response.data.players[0],
          'cap_hit'
        );
        console.log(cols);
        */
        currentComponent.setState({
          columns: currentComponent.projectedColumns,
          teamInfo: response.data,
          forwards: response.data.players.filter(
            x => x.roster_status === 'FORWARDS'
          ),
          defense: response.data.players.filter(
            x => x.roster_status === 'DEFENSE'
          ),
          goalies: response.data.players.filter(
            x => x.roster_status === 'GOALIES'
          ),
          injured: response.data.players.filter(
            x => x.roster_status === 'INJURED'
          ),
          suspended: response.data.players.filter(
            x => x.roster_status === 'SUSPENDED'
          ),
          ltir: response.data.players.filter(
            x => x.roster_status === 'LONG-TERM'
          ),
          soir: response.data.players.filter(x => x.roster_status === 'SEASON'),
          buyout: response.data.players.filter(
            x => x.roster_status === 'BUYOUT'
          ),
          nonRoster: response.data.players.filter(
            x => x.roster_status === 'NON-ROSTER'
          ),
          terminated: response.data.players.filter(
            x => x.roster_status === 'TERMINATED'
          ),
          pto: response.data.players.filter(x => x.roster_status === 'PTO'),
          retained: response.data.players.filter(
            x => x.roster_status === 'RETAINED'
          ),
          buried: response.data.players.filter(
            x => x.roster_status === 'BURIED'
          ),
          recapture: response.data.players.filter(
            x => x.roster_status === 'RECAPTURE'
          )
        });
      })
      .catch(function(error) {
        console.log(error);
      });
    axios
      .get(apiServerUrl + '/team_projected_cap', requestOptions())
      .then(function(response) {
        console.log(response.data);
        currentComponent.setState({
          team_projected_cap: response.data,
          projected_active: response.data.players.filter(
            x => x.roster_status === 'ACTIVE'
          ),
          projected_nonRoster: response.data.players.filter(
            x => x.roster_status === 'NON-ROSTER'
          ),
          projected_nonAsset: response.data.players.filter(
            x => x.roster_status === 'NON-ASSET'
          ),
          projected_soir: response.data.players.filter(
            x => x.roster_status === 'SOIR'
          )
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  openExpand(id) {
    console.log('executing expand ', id);
    this.props.dispatch(push('/players?player_id=' + id));
  }

  getColumns(cols, header) {
    console.log(cols, header, Object.keys(cols));
    let newColumns = [];
    Object.keys(cols).map((key, value) => {
      // console.log(key, value, Object.values(this.props.players)[value]);
      if (
        ['first_name', 'age', 'position', 'statuses', 'contract'].includes(key)
      ) {
        if (key === 'first_name') {
          newColumns.push({
            Header: 'Player',
            accessor: d => d[key] + ' ' + d.last_name,
            id: '0',
            style: { textAlign: 'left', paddingLeft: '1em' },
            defaultSortDesc: false,
            minWidth: 130
          });
        } else if (key === 'age') {
          newColumns.push({
            Header: 'Age',
            accessor: d => d[key],
            id: '5',
            style: { borderRight: '1px solid #778189' },
            defaultSortDesc: false,
            minWidth: 50
          });
        } else if (key === 'statuses') {
          let cols = [
            {
              Header: 'Terms',
              accessor: d => {
                let statuses = [];
                if (d[key].arb_eligible) {
                  statuses.push('ARB');
                } else if (d[key].has_mod_ntc) {
                  statuses.push('M-NTC');
                } else if (d[key].has_nmc) {
                  statuses.push('NMC');
                } else if (d[key].has_ntc) {
                  statuses.push('NTC');
                } else if (d[key].has_retained_sal) {
                  statuses.push('RET SAL');
                } else if (d[key].player_on_elc) {
                  statuses.push('ELC');
                } else if (d[key].potential_perf_bonus) {
                  statuses.push('BONUS');
                } else if (d[key].slide_candidate) {
                  statuses.push('SLIDE');
                } else if (d[key].spc_limit_exempt) {
                  statuses.push('SPC');
                } else if (d[key].thirtyfive_plus) {
                  statuses.push('35+');
                } else if (d[key].waivers_exempt) {
                  statuses.push('WAIVE');
                }
                return statuses;
              },

              id: '1',
              minWidth: 70
            },
            {
              Header: 'Status',
              accessor: d => d[key].expiry_status,
              id: '3',
              minWidth: 50
            },
            {
              Header: 'Two Way',
              accessor: d => (d[key].player_on_two_way ? 'Yes' : 'No'),
              id: '4',
              minWidth: 60
            }
          ];
          newColumns.push(cols[0], cols[1], cols[2]);
        } else if (key === 'position') {
          newColumns.push({
            Header: 'POS',
            accessor: d => d[key],
            id: '2',
            minWidth: 40,
            filterMethod: (filter, row) => {
              return row[filter.id] === filter.value;
            }
          });
        } else if (key === 'contract') {
          let cols = [
            {
              Header: '2018-2019',
              id: '20182019',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20182019')
                    ? d[key].find(x => x.season == '20182019')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20182019')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            },
            {
              Header: '2019-2020',
              id: '20192020',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20192020')
                    ? d[key].find(x => x.season == '20192020')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20192020')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            },
            {
              Header: '2020-2021',
              id: '20202021',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20202021')
                    ? d[key].find(x => x.season == '20202021')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20202021')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            },
            {
              Header: '2021-2022',
              id: '20212022',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20212022')
                    ? d[key].find(x => x.season == '20212022')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20212022')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            },
            {
              Header: '2022-2023',
              id: '20222023',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20222023')
                    ? d[key].find(x => x.season == '20222023')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20222023')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            },
            {
              Header: '2023-2024',
              id: '20232024',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20232024')
                    ? d[key].find(x => x.season == '20232024')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20232024')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            },
            {
              Header: '2024-2025',
              id: '20242025',
              sortMethod: (a, b, desc) => {
                a =
                  a === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        a
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                b =
                  b === null
                    ? desc
                      ? -Infinity
                      : Infinity
                    : Number(
                        b
                          .split('$')[1]
                          .split(',')
                          .join('')
                      );
                if (a > b) {
                  return 1;
                }
                if (a < b) {
                  return -1;
                }
                return 0;
              },
              accessor: d =>
                d[key]
                  ? d[key].find(x => x.season == '20242025')
                    ? d[key].find(x => x.season == '20242025')[header]
                      ? '$' +
                        d[key]
                          .find(x => x.season == '20242025')
                          [header].toLocaleString()
                      : null
                    : null
                  : null
            }
          ];
          newColumns.push(
            cols[0],
            cols[1],
            cols[2],
            cols[3],
            cols[4],
            cols[5],
            cols[6]
          );
        }
      } else {
        return { show: false };
        // this.setState({columns:  })
      }
    });
    console.log(newColumns);
    newColumns.sort(function(a, b) {
      return a.id - b.id;
    });
    return newColumns;
  }

  projectedColumns = [
    {
      Header: 'Name',
      id: 'name',
      accessor: d => d.first_name + ' ' + d.last_name,
      defaultSortDesc: false,
      sortMethod: (a, b) => {
        a = a.split(' ')[1][0];
        b = b.split(' ')[1][0];
        return a < b;
      },
      minWidth: 150
    },
    {
      Header: 'Cap Hit',
      id: 'cap_hit',
      accessor: d =>
        d.cap_hit ? '$' + Math.round(d.cap_hit).toLocaleString() : '$0',
      minWidth: 100
    },
    {
      Header: 'Buried Cap Hit',
      id: 'buried_cap_hit',
      accessor: d =>
        d.buried_cap_hit
          ? '$' + Math.round(d.buried_cap_hit).toLocaleString()
          : null,
      minWidth: 100
    },
    {
      Header: 'Daily Cap Hit',
      id: 'daily_cap_hit',
      accessor: d =>
        d.daily_cap_hit
          ? '$' + Math.round(d.daily_cap_hit).toLocaleString()
          : '$0',
      minWidth: 100
    },
    {
      Header: 'Buried Daily Cap Hit',
      id: 'buried_daily_cap_hit',
      accessor: d =>
        d.buried_daily_cap_hit
          ? '$' + Math.round(d.buried_daily_cap_hit).toLocaleString()
          : null,
      minWidth: 100
    },
    {
      Header: 'Cap To Date',
      id: 'cap_to_date',
      accessor: d =>
        d.cap_to_date ? '$' + Math.round(d.cap_to_date).toLocaleString() : null,
      minWidth: 100
    },
    {
      Header: 'Projected Remaining',
      id: 'projected_remaining',
      accessor: d =>
        d.projected_remaining
          ? '$' + Math.round(d.projected_remaining).toLocaleString()
          : null,
      minWidth: 100
    },
    {
      Header: 'Projected Cap Hit',
      id: 'projected_cap_hit',
      accessor: d =>
        d.projected_cap_hit
          ? '$' + Math.round(d.projected_cap_hit).toLocaleString()
          : null,
      minWidth: 100
    }
  ];

  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
          <ScenarioHeader />
        </header>
        <div
          className="flex-grid"
          style={{ flexDirection: 'column', alignItems: 'stretch' }}
        >
          <div className="cap-top-row">
            {this.state.selection === 'projected' && (
              <div className="cap-stat-row">
                <div className="cap-stat-row-item">
                  <div className="cap-stat-row-item-heading">
                    Projected Cap Hit
                  </div>
                  <div className="cap-stat-row-item-value">
                    $
                    {Math.round(
                      this.state.team_projected_cap.projected_cap_hit
                    ).toLocaleString()}
                  </div>
                </div>
                <div className="cap-stat-row-item">
                  <div className="cap-stat-row-item-heading">
                    Projected LTIR
                  </div>
                  <div className="cap-stat-row-item-value">
                    $
                    {Math.round(
                      this.state.team_projected_cap.projected_ltir_used
                    ).toLocaleString()}
                  </div>
                </div>
                <div className="cap-stat-row-item">
                  <div className="cap-stat-row-item-heading">
                    Projected Cap Space
                  </div>
                  <div className="cap-stat-row-item-value">
                    $
                    {Math.round(
                      this.state.team_projected_cap.projected_cap_space
                    ).toLocaleString()}
                  </div>
                </div>
                <div className="cap-stat-row-item">
                  <div className="cap-stat-row-item-heading">
                    Current Cap Space
                  </div>
                  <div className="cap-stat-row-item-value">
                    $
                    {Math.round(
                      this.state.team_projected_cap.current_cap_space
                    ).toLocaleString()}
                  </div>
                </div>
                <div className="cap-stat-row-item">
                  <div className="cap-stat-row-item-heading">
                    Deadline Cap Space
                  </div>
                  <div className="cap-stat-row-item-value">
                    $
                    {Math.round(
                      this.state.team_projected_cap.deadline_cap_space
                    ).toLocaleString()}
                  </div>
                </div>
                <div className="cap-stat-row-item">
                  <div className="cap-stat-row-item-heading">ACSL</div>
                  <div className="cap-stat-row-item-value">
                    $
                    {Math.round(
                      this.state.team_projected_cap.acsl
                    ).toLocaleString()}
                  </div>
                </div>
                {this.state.team_projected_cap.active_ltir && (
                  <div>
                    <div className="cap-stat-row-item">
                      <div className="cap-stat-row-item-heading">
                        LTIR POOLS
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div className="cap-stat-row-item">
                        <div className="cap-stat-row-item-heading">Relief</div>
                        <div className="ltir-value">
                          Bonus: $
                          {Math.round(
                            this.state.team_projected_cap.ltir_pools.relief
                              .bonus
                          ).toLocaleString()}
                        </div>
                        <div className="ltir-value">
                          Salary: $
                          {Math.round(
                            this.state.team_projected_cap.ltir_pools.relief
                              .salary
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="cap-stat-row-item">
                        <div className="cap-stat-row-item-heading">
                          Remaining
                        </div>
                        <div className="ltir-value">
                          Bonus: $
                          {Math.round(
                            this.state.team_projected_cap.ltir_pools.remaining
                              .bonus
                          ).toLocaleString()}
                        </div>
                        <div className="ltir-value">
                          Salary: $
                          {Math.round(
                            this.state.team_projected_cap.ltir_pools.remaining
                              .salary
                          ).toLocaleString()}
                        </div>
                      </div>
                      <div className="cap-stat-row-item">
                        <div className="cap-stat-row-item-heading">Usage</div>
                        <div className="ltir-value">
                          Bonus: $
                          {Math.round(
                            this.state.team_projected_cap.ltir_pools.usage.bonus
                          ).toLocaleString()}
                        </div>
                        <div className="ltir-value">
                          Salary: $
                          {Math.round(
                            this.state.team_projected_cap.ltir_pools.usage
                              .salary
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {this.state.teamInfo.cap_info &&
              this.state.selection !== 'projected' && (
                <div className="cap-stat-row">
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">Forwards</div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.forwards.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {ordinal(this.state.teamInfo.cap_info.forwards.rank)}
                    </div>
                  </div>
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">Defense</div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.defense.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {ordinal(this.state.teamInfo.cap_info.defense.rank)}
                    </div>
                  </div>
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">Goalies</div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.goalies.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {ordinal(this.state.teamInfo.cap_info.goalies.rank)}
                    </div>
                  </div>
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">
                      Total Cap Value
                    </div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.total_cap.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {ordinal(this.state.teamInfo.cap_info.total_cap.rank)}
                    </div>
                  </div>
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">Total HENRI</div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.total_henri.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {ordinal(this.state.teamInfo.cap_info.total_henri.rank)}
                    </div>
                  </div>
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">
                      Total Surplus
                    </div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.total_surplus.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {ordinal(this.state.teamInfo.cap_info.total_surplus.rank)}
                    </div>
                  </div>
                  <div className="cap-stat-row-item">
                    <div className="cap-stat-row-item-heading">
                      Total Buyout
                    </div>
                    <div className="cap-stat-row-item-value">
                      $
                      {this.state.teamInfo.cap_info.buyout &&
                        this.state.teamInfo.cap_info.buyout.amount.toLocaleString()}
                    </div>
                    <div className="cap-stat-row-item-subheading">
                      NHL Rank:{' '}
                      {this.state.teamInfo.cap_info.buyout &&
                        ordinal(this.state.teamInfo.cap_info.buyout.rank)}
                    </div>
                  </div>
                </div>
              )}
          </div>

          <div className="cap-team-dropdown-box">
            <select
              className="cap-team-dropdown"
              onChange={e => this.changeTeam(e)}
            >
              <AppContext.Consumer>
                {context =>
                  context.number.map(item => (
                    <option
                      selected={this.state.homeTeam == item.abbreviation}
                      value={item.abbreviation}
                    >
                      {item.full_team_name}
                    </option>
                  ))
                }
              </AppContext.Consumer>
            </select>
          </div>

          {this.state.teamInfo.players && (
            <div className="cap-bottom-row">
              <div className="cap-table-header-row">
                <div
                  onClick={this.activateLasers.bind(this, 'cap')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'cap_hit' ? '#082539' : '#2f526c'
                  }}
                >
                  CAP HIT
                </div>
                <div
                  onClick={this.activateLasers.bind(this, 'aav')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'aav' ? '#082539' : '#2f526c'
                  }}
                >
                  AAV
                </div>
                <div
                  onClick={this.activateLasers.bind(this, 'henri')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'henri' ? '#082539' : '#2f526c'
                  }}
                >
                  HENRI
                </div>
                <div
                  onClick={this.activateLasers.bind(this, 'surplus')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'surplus' ? '#082539' : '#2f526c'
                  }}
                >
                  SURPLUS
                </div>
                <div
                  onClick={this.activateLasers.bind(this, 'sign')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'sign' ? '#082539' : '#2f526c'
                  }}
                >
                  SIGNING BONUS
                </div>
                <div
                  onClick={this.activateLasers.bind(this, 'perf')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'perf' ? '#082539' : '#2f526c'
                  }}
                >
                  PERFORMANCE BONUS
                </div>
                <div
                  onClick={this.activateLasers.bind(this, 'minors')}
                  className="cap-table-header-tab"
                  style={{
                    backgroundColor:
                      this.state.selection == 'minors' ? '#082539' : '#2f526c'
                  }}
                >
                  MINOR SALARIES
                </div>
                {this.state.projected && (
                  <div
                    onClick={this.activateLasers.bind(this, 'projected')}
                    className="cap-table-header-tab"
                    style={{
                      backgroundColor:
                        this.state.selection == 'projected'
                          ? '#082539'
                          : '#2f526c'
                    }}
                  >
                    PROJECTED
                  </div>
                )}
              </div>
              <div>
                {this.state.selection === 'projected' && (
                  <div>
                    <div className="cap-table-box">
                      <div className="table-label">ACTIVE PLAYERS</div>
                      <ReactTable
                        data={this.state.projected_active}
                        columns={this.state.columns}
                        showPagination={false}
                        sortable={true}
                        defaultSortDesc={true}
                        defaultSorted={[{ id: 'cap_hit', desc: true }]}
                        defaultSortMethod={(a, b, desc) => {
                          a =
                            a === null
                              ? desc
                                ? -Infinity
                                : Infinity
                              : Number(
                                  a
                                    .split('$')[1]
                                    .split(',')
                                    .join('')
                                );
                          b =
                            b === null
                              ? desc
                                ? -Infinity
                                : Infinity
                              : Number(
                                  b
                                    .split('$')[1]
                                    .split(',')
                                    .join('')
                                );
                          if (a > b) {
                            return 1;
                          }
                          if (a < b) {
                            return -1;
                          }
                          return 0;
                        }}
                        resizable={false}
                        getTrProps={(instance, rowInfo) => ({
                          onClick: () => {
                            this.openExpand(
                              instance.data[rowInfo.index].player_id
                            );
                          }
                        })}
                        pageSize={this.state.projected_active.length}
                        className="-striped -highlight"
                      />
                    </div>
                    <div className="cap-table-box">
                      <div className="table-label">NON-ROSTER</div>
                      <ReactTable
                        data={this.state.projected_nonRoster}
                        columns={this.state.columns}
                        showPagination={false}
                        sortable={true}
                        defaultSortDesc={true}
                        defaultSorted={[{ id: 'cap_hit', desc: true }]}
                        defaultSortMethod={(a, b, desc) => {
                          a =
                            a === null
                              ? desc
                                ? -Infinity
                                : Infinity
                              : Number(
                                  a
                                    .split('$')[1]
                                    .split(',')
                                    .join('')
                                );
                          b =
                            b === null
                              ? desc
                                ? -Infinity
                                : Infinity
                              : Number(
                                  b
                                    .split('$')[1]
                                    .split(',')
                                    .join('')
                                );
                          if (a > b) {
                            return 1;
                          }
                          if (a < b) {
                            return -1;
                          }
                          return 0;
                        }}
                        resizable={false}
                        getTrProps={(instance, rowInfo) => ({
                          onClick: () => {
                            this.openExpand(
                              instance.data[rowInfo.index].player_id
                            );
                          }
                        })}
                        pageSize={this.state.projected_nonRoster.length}
                        className="-striped -highlight"
                      />
                    </div>
                    {this.state.projected_nonAsset.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">NON-ASSETS</div>
                        <ReactTable
                          data={this.state.projected_nonAsset}
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: 'cap_hit', desc: true }]}
                          defaultSortMethod={(a, b, desc) => {
                            a =
                              a === null
                                ? desc
                                  ? -Infinity
                                  : Infinity
                                : Number(
                                    a
                                      .split('$')[1]
                                      .split(',')
                                      .join('')
                                  );
                            b =
                              b === null
                                ? desc
                                  ? -Infinity
                                  : Infinity
                                : Number(
                                    b
                                      .split('$')[1]
                                      .split(',')
                                      .join('')
                                  );
                            if (a > b) {
                              return 1;
                            }
                            if (a < b) {
                              return -1;
                            }
                            return 0;
                          }}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].player_id
                              );
                            }
                          })}
                          pageSize={this.state.projected_nonAsset.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.projected_soir.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Season Opening IR</div>
                        <ReactTable
                          data={this.state.projected_soir}
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: 'cap_hit', desc: true }]}
                          defaultSortMethod={(a, b, desc) => {
                            a =
                              a === null
                                ? desc
                                  ? -Infinity
                                  : Infinity
                                : Number(
                                    a
                                      .split('$')[1]
                                      .split(',')
                                      .join('')
                                  );
                            b =
                              b === null
                                ? desc
                                  ? -Infinity
                                  : Infinity
                                : Number(
                                    b
                                      .split('$')[1]
                                      .split(',')
                                      .join('')
                                  );
                            if (a > b) {
                              return 1;
                            }
                            if (a < b) {
                              return -1;
                            }
                            return 0;
                          }}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].player_id
                              );
                            }
                          })}
                          pageSize={this.state.projected_soir.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                  </div>
                )}
                {this.state.selection !== 'projected' && (
                  <div>
                    <div className="cap-table-box">
                      <div className="table-label">Forwards</div>
                      <ReactTable
                        data={this.state.forwards}
                        ref="forwardsTable"
                        columns={this.state.columns}
                        showPagination={false}
                        sortable={true}
                        defaultSortDesc={true}
                        defaultSorted={[{ id: '20182019', desc: true }]}
                        resizable={false}
                        getTrProps={(instance, rowInfo) => ({
                          onClick: () => {
                            this.openExpand(
                              instance.data[rowInfo.index].playerid
                            );
                          }
                        })}
                        pageSize={this.state.forwards.length}
                        className="-striped -highlight"
                      />
                    </div>
                    <div className="cap-table-box">
                      <div className="table-label">Defense</div>
                      <ReactTable
                        data={this.state.defense}
                        ref="defenseTable"
                        columns={this.state.columns}
                        showPagination={false}
                        sortable={true}
                        defaultSortDesc={true}
                        defaultSorted={[{ id: '20182019', desc: true }]}
                        resizable={false}
                        getTrProps={(instance, rowInfo) => ({
                          onClick: () => {
                            this.openExpand(
                              instance.data[rowInfo.index].playerid
                            );
                          }
                        })}
                        pageSize={this.state.defense.length}
                        className="-striped -highlight"
                      />
                    </div>
                    <div className="cap-table-box">
                      <div className="table-label">Goalies</div>
                      <ReactTable
                        data={this.state.goalies}
                        ref="goalieTable"
                        columns={this.state.columns}
                        showPagination={false}
                        sortable={true}
                        defaultSortDesc={true}
                        defaultSorted={[{ id: '20182019', desc: true }]}
                        resizable={false}
                        getTrProps={(instance, rowInfo) => ({
                          onClick: () => {
                            this.openExpand(
                              instance.data[rowInfo.index].playerid
                            );
                          }
                        })}
                        pageSize={this.state.goalies.length}
                        className="-striped -highlight"
                      />
                    </div>
                    {this.state.injured.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Injured Players</div>
                        <ReactTable
                          data={this.state.injured}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.injured.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.suspended.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Suspended Players</div>
                        <ReactTable
                          data={this.state.suspended}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.suspended.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.ltir.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Long-Term IR</div>
                        <ReactTable
                          data={this.state.ltir}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.ltir.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.soir.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Season Opening IR</div>
                        <ReactTable
                          data={this.state.soir}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.soir.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.buyout.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Buyout Players</div>
                        <ReactTable
                          data={this.state.buyout}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.buyout.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.nonRoster.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Non-Rostered Players</div>
                        <ReactTable
                          data={this.state.nonRoster}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.nonRoster.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.terminated.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Terminated Contracts</div>
                        <ReactTable
                          data={this.state.terminated}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.terminated.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.pto.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Professional Tryout</div>
                        <ReactTable
                          data={this.state.pto}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.pto.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.retained.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Retained Salaries</div>
                        <ReactTable
                          data={this.state.retained}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.retained.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.buried.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Buried Contracts</div>
                        <ReactTable
                          data={this.state.buried}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.buried.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                    {this.state.recapture.length >= 1 && (
                      <div className="cap-table-box">
                        <div className="table-label">Recaptured Contracts</div>
                        <ReactTable
                          data={this.state.recapture}
                          ref="nonRosteredTable"
                          columns={this.state.columns}
                          showPagination={false}
                          sortable={true}
                          defaultSortDesc={true}
                          defaultSorted={[{ id: '20182019', desc: true }]}
                          resizable={false}
                          getTrProps={(instance, rowInfo) => ({
                            onClick: () => {
                              this.openExpand(
                                instance.data[rowInfo.index].playerid
                              );
                            }
                          })}
                          pageSize={this.state.recapture.length}
                          className="-striped -highlight"
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedCapManagement = connect(mapStateToProps)(CapManagement);
export { connectedCapManagement as CapManagement };



// WEBPACK FOOTER //
// ./src/Pages/CapManagement.js